import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OnboardingStateService } from '@core/services/onboarding-state.service';

export const onboardingGuard: CanActivateFn = async () => {
  const onboardingState = inject(OnboardingStateService);
  const router = inject(Router);

  const completed = await onboardingState.checkOnboardingStatus();
  if (completed) {
    return router.parseUrl('/home');
  }

  return true;
};
